jQuery(document).ready(function ($) {

    /*
     *
     * SVG management
     * replace .svg by .png on ie 7/8
     */
    if ($('html').hasClass('no-svg'))
    {
        $('img[src$=".svg"]').each(function ()
        {
            $(this).attr('src', $(this).attr('src').replace('.svg', '.png'));
        });
    }

    $('#main-sidebar').simpleSidebar({
        opener: '#toggle-sidebar',
        wrapper: '#main',
        animation: {
          easing: 'easeOutQuint'
        },
        sidebar: {
          align: 'right',
          closingLinks: '.close-sb'
        },
        sbWrapper: {
          display: true
        }
    });
    
    if($('.display_detail').length > 0){
        $('.product img, .display_detail').each(function(i,e){
            $(e).mouseover(function(){
                $(e).parent().addClass('active');
            });
        });
        
        $('.display_detail, .detail').mouseleave(function(){
            $(this).parent().removeClass('active').delay(1000);
        });
    }
});
